import { BaseNotificationContextEnum } from './base-notification-context.enum';

/**
 * Vehicle road worthy check notification context enum
 * @description Notification contexts specific to vehicle road worthy check subjects (MOT/inspection)
 */
export enum VehicleRoadWorthyCheckNotificationContextEnum {
	// Base contexts
	INSERTED = BaseNotificationContextEnum.INSERTED,
	UPDATED = BaseNotificationContextEnum.UPDATED,
	DELETED = BaseNotificationContextEnum.DELETED,

	// Vehicle road worthy check-specific contexts
	PENDING = 'pending',
	ACTIVE = 'active',
	EXPIRED = 'expired',
}
